export const GROUP_TYPE_PRODUCTS = "product_alternatives";
export const GROUP_TYPE_SETTINGS = "group_settings";
export const GROUP_TYPES = [GROUP_TYPE_PRODUCTS, GROUP_TYPE_SETTINGS];
